import { createFeatureSelector } from '@ngrx/store';
import { DotCmsConfigurableContentsState } from './dotcms-configurable-contents/dotcms-configurable-contents.reducer';
import { DotCmsConfigurationState } from './dotcms-configuration/dotcms-configuration.reducer';
import { DotCmsContainerState } from './dotcms-container/dotcms-container.reducer';
import { DotCmsContentletsState } from './dotcms-contentlets/dotcms-contentlets.reducer';
import { DotCmsNavigationState } from './dotcms-navigation/dotcms-navigation.reducer';
import { DotCmsPagesState } from './dotcms-pages/dotcms-pages.reducer';

export interface DotCmsState {
  configuration: DotCmsConfigurationState;
  pages: DotCmsPagesState;
  contentlets: DotCmsContentletsState;
  navigation: DotCmsNavigationState;
  containers: DotCmsContainerState;
  configurableContents: DotCmsConfigurableContentsState;
}

export const getDotCmsState = createFeatureSelector<DotCmsState>('dotCms');
